import Vue from 'vue'
import axios from 'axios'
import { io } from 'socket.io-client'

let jukebox = null

export const state = () => {
  return {
    playingTrack: null,
    isActive: false,
    repeat: 'off',
    shuffle: 'off',
    consumeTime: 0,
    freeTimeReachedModal: false,
    modalSelectPlaylist: false,
    modalSelectPlaylistAction: null
  }
}

export const mutations = {
  SET_ACTIVE (state, active) {
    state.isActive = active
  },
  SET_PLAYING (state, trackId) {
    state.playingTrack = trackId
  },
  SET_SHUFFLE (state, shuffle) {
    state.shuffle = shuffle
  },
  SET_REPEAT (state, repeat) {
    state.repeat = repeat
  },
  UPDATE_CONSUME_TIME (state, consumeTime) {
    state.consumeTime = consumeTime
  },
  UPDATE_FREE_TIME_REACHED_MODAL (state, timeReached) {
    state.freeTimeReachedModal = timeReached
  },
  SHOW_MODAL_PLAYLIST_SELECT (state, action) {
    state.modalSelectPlaylistAction = typeof action === 'function' ? action : null
    state.modalSelectPlaylist = !!action
  }
}

export const actions = {
  hasInstance () {
    return jukebox !== null
  },
  selectPlaylist ({ commit, state }, playlist) {
    if (state.modalSelectPlaylistAction) {
      state.modalSelectPlaylistAction(playlist)
    }

    commit('SHOW_MODAL_PLAYLIST_SELECT', false)
  },
  getInstance ({ dispatch }) {
    return dispatch('initialize')
      .then(() => {
        return jukebox
      })
  },
  initialize ({ commit }) {
    if (jukebox !== null) {
      return Promise.resolve()
    }

    return import('../assets/js/jukebox/jukebox-sdk.js').then(() => {
      const axiosInstance = axios.create({
        headers: {
          Authorization: this.$auth.strategy.token.get()
        }
      })

      jukebox = window.Jukebox(
        Vue,
        axiosInstance,
        io,
        process.env.JUKEBOX_MUSIC_URL
      )

      jukebox.on('player.play', () => {
        commit('SET_ACTIVE', true)

        if (jukebox.state.track) {
          commit('SET_PLAYING', jukebox.state.track.id)
        }
      })

      jukebox.on('player.pause', () => {
        commit('SET_PLAYING', null)
      })
      jukebox.on('state.updated', (state) => {
        if (state.percentCompleted >= 100) {
          commit('SET_PLAYING', null)
        }
      })

      jukebox.on('user.updateConsumeTime', (data) => {
        commit('UPDATE_CONSUME_TIME', data.time_consumed)
      })

      jukebox.on('error', (error) => {
        if (error === 'FREE_TIME_REACHED') {
          commit('UPDATE_FREE_TIME_REACHED_MODAL', 'music_limit')
        }
      })

      return jukebox.authenticate(this.$auth.strategy.token.get())
    })
  }
}

export const getters = {
  isActive: (state) => {
    return state.isActive
  }
}
